import { constants } from "redux/constants/redux-constants";

const initialState = {
    showBackdrop: false,
};

export const backDropReducer = (state = initialState, action) => {
    switch (action.type) {
      case constants.SET_SHOW_BACKDROP:
        return {
          ...state,
          showBackdrop: action.payload,
        };
      default:
        return state;
    }
};